import { LitElement, html, css } from "lit";
import "@matter/matter-icon/dist/matter-icon.js";

class MatterAjaxList extends LitElement {
  static get styles() {
    return css`
      :host {
        display: block;
        font-family: Source Sans Pro, sans-serif;

        --main-hover: #0b4c1a;
        --main: #087021;
        --main-help: #c4ddca;
        --main-specific-help: #f7fbf8;
        --main-backgroung: #ffffff;

        --grey-main: #333333;
        --grey-help: #bebebe;
        --grey-container: #eeeeee;
        --grey-specific-help: #f5f5f5;

        --status-success: #2abc67;
        --status-info: #5bc0de;
        --status-warning: #f0ad4e;
        --status-error: #d9534f;

        --graph-1: #77b5c3;
        --graph-2: #4863a3;
        --graph-3: #9371ac;
        --graph-4: #d87d7d;
        --graph-5: #d9a46c;
        --graph-6: #e3cd66;
      }

      :host([detail_hidden]) .detail {
        display: none;
      }

      p.mt-0{
        margin-top: 0;
      }

      span,
      a {
        color: var(--main);
        text-decoration: none;
        font-weight: 400;
      }

      a:hover {
        color: #0b4c1a;
        text-decoration: underline;
      }

      a:hover span {
        color: #0b4c1a;
      }

      .title {
        margin-bottom: 2.1875rem;
        font-size: 1.25rem;
        font-weight: bold;
        color: var(--gray);
      }

      .container {
        display: flex;
        flex-direction: row;
        margin-bottom: 1.125rem;
      }

      .date {
        text-align: center;
      }

      .date span {
        display: block;
        font-size: 0.625rem;
      }

      .date span:first-child {
        font-size: 1.125rem;
        font-weight: bold;
      }

      .line {
        border-left: 0.125rem solid var(--main);
        height: 2.6875rem;
        margin: 0.375rem 0.625rem 0 0.5rem;
      }

      .text {
        font-size: 0.875rem;
      }

      .detail a {
        font-size: 0.875rem;
        font-weight: bold;
        line-height: 1.5;
        float: right;
        position: relative;
      }

      .detail .icon {
        position: absolute;
        top: 0;
      }

      .detail .text {
        margin-left: 14px;
        font-weight: bold;
      }

      .results {
        padding: 0;
        list-style: none;
        margin-left: 2.5%;
        margin-right: 2.5%;
      }

      .results li {
        width: 100%;
        padding: 0;
        display: inline-block;
      }

      .results-vertical {
        padding: 0;
        list-style: none;
        margin-left: 2.5%;
        margin-right: 2.5%;
        display: flex;
        flex-wrap: wrap;
      }

      .results-vertical li {
        width: 30%;
        padding: 0;
        display: flex;
        flex-wrap: wrap;
        padding-right: 25px;
      }

      .title {
        color: #087021;

        font-size: 18px;
        font-weight: bold;
        line-height: 1.5;
        align-self: flex-start;
      }

      .title-vertical {
        color: #333333;

        font-size: 16px;
        font-weight: bold;
        line-height: 1.5;
      }

      .subtitle {
        color: #333333;

        font-size: 14px;
        font-weight: 600;
        line-height: 1.5;
      }

      .description {
        color: #333333;

        font-size: 14px;
        font-weight: 300;
        line-height: 1.5;
      }

      .description-vertical {
        color: #333333;

        font-size: 14px;
        font-weight: 300;
        line-height: 1.5;
      }

      .link {
        color: #087021;
        position: relative;
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        text-decoration: none;
      }

      .link:hover span {
        color: #0b4c1a;
      }

      .link .icon {
        position: absolute;
        top: 0;
      }

      .link .text {
        margin-left: 14px;
        font-weight: bold;
      }

      .left {
        float: left;
        width: 20%;
      }

      .right {
        float: right;
        width: 79%;
        margin-left: 1%;
      }

      .bottom {
        margin-left: 21%;
      }

      .image {
        width: 100%;
        height: 70%;
      }

      .separator {
        border-bottom: 1px solid #d8d8d8;
        width: 100%;
        border-radius: 0.25px;
      }

      .enlace {
        align-self: flex-end;
      }

      .enlace .link {
        position: relative;
      }

      .enlace .link .icon {
        position: absolute;
        top: 0;
      }

      .enlace .link .text {
        margin-left: 14px;
        font-weight: bold;
      }

      @media only screen and (max-width: 480px) {
        .title-vertical {
          font-size: 16px;
          line-height: 1.5;
        }

        .results-vertical li {
          width: 90%;
        }

        .results-vertical {
          padding: 0;
          margin-left: 2.5%;
          margin-right: 2.5%;
        }

        .vertical {
          padding-right: 0;
        }

        .title {
          font-size: 16px;
          line-height: 1.5;
        }

        .subtitle {
          font-size: 14px;
          line-height: 1.5;
        }

        .description {
          font-size: 14px;
          line-height: 1.5;
        }

        .link {
          font-size: 14px;
          line-height: 1.5;
        }

        .left {
          display: none;
        }

        .right {
          width: 100%;
        }

        .bottom {
          margin: 0;
        }
      }
    `;
  }

  static get properties() {
    return {
      response: { type: Array, attribute: true },
      endpointUrl: { type: String, reflect: true },
      elements: { type: Array },
      inputTitle: { type: String },
      inputDescription: { type: String },
      inputParametroFecha: { type: String },
      inputType: { type: String },
      inputMoreInformationURL: { type: String },
      inputDocumentURL: { type: String },
      inputImageURL: { type: String },
      inputLang: { type: String },
      inputHeaderTitle: { type: String },
      inputUrl: { type: String },
      inputPrefixUrl: { type: String },
      inputSufixUrl: { type: String },
      inputFullLink: { type: String },
      inputFullLinkName: { type: String },
      iconInputFullLink: { type: String },
      iconFamInputFullLink: { type: String },
      verticalLayout: { type: String },
      scheduleLayout: { type: String },
      inputNodeRoot: { type: String },
      inputTotalElements: { type: Number },
      _error: { type: String },
    };
  }

  constructor() {
    super();
    this.response = [];
    this.elements = [];
    this.endpointUrl = "";
    this.inputTitle = "";
    this.inputDescription = "";
    this.inputParametroFecha = "";
    this.inputType = "";
    this.inputMoreInformationURL = "";
    this.inputDocumentURL = "";
    this.inputImageURL = "";
    this.inputLang = "";
    this.inputHeaderTitle = "";
    this.inputUrl = "";
    this.inputPrefixUrl = "";
    this.inputSufixUrl = "";
    this.inputFullLink = "";
    this.inputFullLinkName = "";
    this.iconInputFullLink = "";
    this.iconFamInputFullLink = "";
    this.verticalLayout = "false";
    this.scheduleLayout = "false";
    this.inputNodeRoot = "";
    this.inputTotalElements = 1;
  }
  addFont() {
    const sourceSans = document.createElement("link");
    sourceSans.href =
      "https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@300;400;600;700&display=swap";
    sourceSans.rel = "stylesheet";
    document.head.append(sourceSans);
  }

  render() {
    let render;
    if (this.scheduleLayout == "true" && this.verticalLayout == "false") {
      /* CASO: MODO AGENDA */
      this._error
        ? (render = html` <div class="error">${this._error}</div> `)
        : (render = html`
            <div class="title">${this.inputHeaderTitle}</div>

            ${this.response.map(
              (item) =>
                html`
                  <div class="container">
                    <div class="date">
                      ${this.getDate(item.date).map(
                        (date) => html` <span>${date}</span> `
                      )}
                    </div>
                    <div class="line"></div>
                    <p class="mt-0">
                      <a href=${item.url} title=${item.title} class="text">${item.title}</a>
                    </p>
                  </div>
                `
            )}
            ${this.inputFullLink
              ? html`
                  <div class="detail">
                    <a style="display:flex;"
                      href=${this.inputFullLink}
                      title=${this.inputFullLinkName}
                      >
                      <matter-icon style="display:flex;align-items: center;" color=var(--main) family=${this.iconFamInputFullLink} icon=${this.iconInputFullLink}></matter-icon>
                      <span class="text">${this.inputFullLinkName}</span></a
                    >
                  </div>
                `
              : html``}
          `);
    } else if (this.verticalLayout == "true" && this.scheduleLayout == "false") {
      /* CASO: VERTICAL LAYOUT */
      this._error
        ? (render = html` <div class="error">${this._error}</div> `)
        : (render = html`
            <ul class="results-vertical">
              ${this.response.map(
                (item) => html`
                  <li class="separator vertical">
                    <p class="title-vertical" style="line-height:1.5;">
                      ${this.convertHTML(item.title)}
                    </p>
                    <p class="description-vertical" style="line-height:1.5;">
                      ${this.convertHTML(item.description)}
                    </p>

                    ${this.inputFullLink
                      ? html`
                          <p class="enlace" style="line-height:1.5;">
                            <a style="display:flex;"
                              class="link"
                              href="${this.inputFullLink}"
                              title="${this.inputFullLinkName}"
                              >
                              <matter-icon style="display:flex;align-items: center;" color=var(--main) family=${this.iconFamInputFullLink} icon=${this.iconInputFullLink}></matter-icon>
                              <span class="text">${this.inputFullLinkName}</span
                              ></a
                            >
                          </p>
                        `
                      : html``}
                  </li>
                `
              )}
            </ul>
          `);
    } else {
      this._error
        ? (render = html` <div class="error">${this._error}</div> `)
        : (render = html`
            <ul class="results">
              ${this.response.map(
                (item) => html`
                  <li class="separator">
                    <!-- CASO 1: SÍ HAY IMAGEN -->
                    ${item.imageURL
                      ? html`
                          <div class="left">
                            <p style="line-height:1.5;">
                              <img
                                class="image"
                                alt="${item.title}"
                                src="${item.imageURL}"
                              />
                            </p>
                          </div>

                          <div class="right">
                            ${item.title
                              ? html`
                                  <p style="line-height:1.5;">
                                    <a
                                      class="title"
                                      href="${item.url}"
                                      title="${item.title}"
                                      >${this.convertHTML(item.title)}</a
                                    >
                                  </p>
                                `
                              : html``}
                            ${item.type || item.date
                              ? html`
                                  <p class="subtitle" style="line-height:1.5;">
                                    ${item.type} · ${item.date}
                                  </p>
                                `
                              : html``}
                          </div>

                          <div class="bottom">
                            ${item.description
                              ? html`
                                  <p class="description" style="line-height:1.5;">
                                    ${this.convertHTML(item.description)}
                                  </p>
                                `
                              : html``}
                            ${item.url
                              ? html`
                                  <p style="line-height:1.5;">
                                    <a style="display:flex;"
                                      class="link"
                                      href="${item.url}"
                                      title="Más Información"
                                      >
                                      <matter-icon style="display:flex;align-items: center;" color=var(--main) family=${this.iconFamInputFullLink} icon=${this.iconInputFullLink}></matter-icon>
                                      <span class="text">Más información</span
                                      ></a
                                    >
                                  </p>
                                `
                              : html``}
                            ${item.documentURL
                              ? html`
                                  <p>
                                    <a style="display:flex;"
                                      class="link"
                                      href="${item.documentURL}"
                                      title="Ver Documento"
                                      >
                                      <matter-icon style="display:flex;align-items: center;" color=var(--main) family=${this.iconFamInputFullLink} icon=${this.iconInputFullLink}></matter-icon>
                                      <span class="text">Ver Documento</span
                                      ></a
                                    >
                                  </p>
                                `
                              : html``}
                          </div>
                        `
                      : html`
                          <!-- CASO 2: NO HAY IMAGEN -->
                          <p style="line-height:1.5;">
                            <a
                              class="title"
                              href="${item.url}"
                              title="${item.title}"
                              >${this.convertHTML(item.title)}</a
                            >
                          </p>

                          ${item.type || item.date
                            ? html`
                                <p class="subtitle" style="line-height:1.5;">
                                  ${item.type} · ${item.date}
                                </p>
                              `
                            : html``}

                          <p class="description" style="line-height:1.5;">
                            ${this.convertHTML(item.description)}
                          </p>

                          ${item.url
                            ? html`
                                <p style="line-height:1.5;">
                                  <a style="display:flex;"
                                    class="link"
                                    href="${item.url}"
                                    title="Más Información"
                                    >
                                    <matter-icon style="display:flex;align-items: center;" color=var(--main) family=${this.iconFamInputFullLink} icon=${this.iconInputFullLink}></matter-icon>
                                    <span class="text"
                                      >Más información</span
                                    ></a
                                  >
                                </p>
                              `
                            : html``}
                          ${item.documentURL
                            ? html`
                                <p style="line-height:1.5;">
                                  <a
                                    class="link"
                                    href="${item.documentURL}"
                                    title="Ver Documento"
                                    >&#9205; Ver Documento</a
                                  >
                                </p>
                              `
                            : html``}
                        `}
                  </li>
                `
              )}
            </ul>
          `);
    }
    return render;
  }

  updated(changedProperties) {
    changedProperties.forEach((_, propName) => {
      if (["endpointUrl", "inputTotalElements"].includes(propName)) {
        this.updatedResponse();
      }
    });
    this.addFont();
  }

  // eslint-disable-next-line class-methods-use-this
  getDate(date) {
    const result = [];

    if (date && date.indexOf("/")) {
      const parts = date.split("/");

      if (parts.length === 3) {
        const fecha = new Date(+parts[2], parts[1] - 1, +parts[0]);

        result.push(fecha.getDate().toString());
        result.push(
          fecha
            .toLocaleString(this.inputLang, { month: "short" })
            .replace(".", "")
            .toUpperCase()
        );
        result.push(fecha.getFullYear().toString());
      }
    }

    return result;
  }

  // eslint-disable-next-line class-methods-use-this
  formatDate(date) {
    const year = date.getFullYear();

    let month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : `0${month}`;

    let day = date.getDate().toString();
    day = day.length > 1 ? day : `0${day}`;

    return `${day}/${month}/${year}`;
  }

  // Metodo que recorre el JSON hasta llegar al atributo seleccionado
  // eslint-disable-next-line class-methods-use-this
  lookupPosition(str, _res) {
    str.forEach((i) => {
      _res = _res[i];
    });

    return _res;
  }

  /* eslint-disable */
  findElementIntoJSON(element) {
    const root = {};
    (function levels(data, index) {
      const suffix =
        Object.prototype.toString.call(data) === "[object Array]" ? "]" : "";

      for (const key in data) {
        if (!data.hasOwnProperty(key)) {
          continue;
        }

        root[index + key + suffix] = data[key];

        if (Object.prototype.toString.call(data[key]) === "[object Array]") {
          levels(data[key], `${index + key + suffix}[`);
        }

        if (
          Object.prototype.toString.call(data[key]) === "[object Object]"
        ) {
          levels(data[key], `${index + key + suffix}.`);
        }
      }
    })(element, "");
    return root;
  }
  /* eslint-enable */

  // eslint-disable-next-line class-methods-use-this
  convertHTML(data) {
    const decodeHTML = function (htmlData) {
      const txt = document.createElement("textarea");
      txt.innerHTML = htmlData;
      return txt.value;
    };
    const temp = document.createElement("div");
    temp.innerHTML = decodeHTML(data);
    return temp.textContent || temp.innerText || "";
  }

  updatedResponse() {
    /* Reestablecemos la variable de error para evitar que salga mensaje anterior */
    this._error = "";

    let urlAux = this.endpointUrl;
    urlAux = urlAux.replace(/&amp;/g, "&");
    urlAux = urlAux.replace(/&gt;/g, ">");

    if (urlAux !== undefined && urlAux !== null && urlAux !== "") {
      urlAux = urlAux.replace("&amp;", "&");

      window
        .fetch(urlAux, {
          mode: "cors",
        })
        .then((response) => {
          if (response.ok) {
            response
              .json()
              .then((responseJSON) => {
                let elements = [];

                // Obtenemos la raiz del array
                let _res = responseJSON;
                if (this.inputNodeRoot) {
                  const str = this.inputNodeRoot.split(".");
                  _res = this.lookupPosition(str, _res);
                }

                // Recorro los distintos objetos en busca de los atributos
                _res.forEach((item) => {
                  const objAux = this.findElementIntoJSON(item);

                  /* INPUT TITLE */
                  const title = objAux[this.inputTitle]
                    ? objAux[this.inputTitle]
                    : "";

                  /* INPUT DESCRIPTION */
                  const description = objAux[this.inputDescription]
                    ? objAux[this.inputDescription]
                    : "";

                  /* INPUT DATE */

                  let date = null;

                  Date.prototype.yyyymmdd = function () {
                    const mm = this.getMonth() + 1; // getMonth() is zero-based
                    const dd = this.getDate();

                    return [
                      this.getFullYear(),
                      (mm > 9 ? "" : "0") + mm,
                      (dd > 9 ? "" : "0") + dd,
                    ].join("");
                  };

                  if (Array.isArray(objAux[this.inputParametroFecha])) {
                    const now = new Date();
                    objAux[this.inputParametroFecha].forEach((d) => {
                      const dateAux = new Date(d);

                      if (
                        (date == null &&
                          dateAux.yyyymmdd() >= now.yyyymmdd()) ||
                        (date != null &&
                          dateAux.yyyymmdd() >= now.yyyymmdd() &&
                          dateAux.yyyymmdd() <= date.yyyymmdd())
                      ) {
                        date = new Date(d);
                      }
                    });

                    date = this.formatDate(date);
                  } else if (objAux[this.inputParametroFecha]) {
                    date = this.formatDate(new Date(objAux[this.inputParametroFecha]));
                  }

                  /* URL */
                  let url = "";
                  if (objAux[this.inputUrl]) {
                    if (this.inputPrefixUrl) {
                      url += this.inputPrefixUrl;
                    }

                    url += objAux[this.inputUrl];

                    if (this.inputSufixUrl) {
                      url += this.inputSufixUrl;
                    }
                  }

                  const type = objAux[this.inputType]
                    ? objAux[this.inputType]
                    : "";
                  const moreInformationURL = objAux[
                    this.inputMoreInformationURL
                  ]
                    ? objAux[this.inputMoreInformationURL]
                    : "";
                  const documentURL = objAux[this.inputDocumentURL]
                    ? objAux[this.inputDocumentURL]
                    : "";
                  const imageURL = objAux[this.inputImageURL]
                    ? objAux[this.inputImageURL].replace(
                        "public://",
                        "http://pdpjda-drupal-plataforma-tecnologica.apps-des.sandetel.junta-andalucia.es/sites/default/files/"
                      )
                    : "";

                  elements.push({
                    title,
                    description,
                    date,
                    type,
                    moreInformationURL,
                    documentURL,
                    imageURL,
                    url,
                  });
                });

                /* ELIMINO DEL ARRAY LOS ELEMENTOS QUE NO QUIERO Y ME QUEDO AQUELLOS QUE SI */
                if (this.inputTotalElements) {
                  let totalToShow = null;

                  if (this.inputTotalElements < 0) {
                    totalToShow = 1;
                  } else if (this.inputTotalElements > elements.length) {
                    totalToShow = elements.length;
                  } else {
                    totalToShow = this.inputTotalElements;
                  }

                  if (totalToShow) {
                    elements = elements.filter((value, index) => {
                      if (index < totalToShow) return value;
                    });
                  }
                }

                this.response = elements;
              })
              .catch((error) => {});
          }
        })
        .catch((error) => {});
    }
  }
}

if (!window.customElements.get("matter-ajax-list")) {
  window.customElements.define("matter-ajax-list", MatterAjaxList);
}
